import { render, staticRenderFns } from "./SlideTitleSettingsV2.vue?vue&type=template&id=cb4a4dc6"
import script from "./SlideTitleSettingsV2.vue?vue&type=script&lang=js"
export * from "./SlideTitleSettingsV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports